// Business times in dForms are India time (Asia/Kolkata), whatever the
// viewer's device or the server is set to. Used by Results and Activity.

export const INDIA_TZ = "Asia/Kolkata";

const DATE_TIME = { timeZone: INDIA_TZ, day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
const DATE_ONLY = { timeZone: INDIA_TZ, day: "numeric", month: "short", year: "numeric" };

const toDate = (value) => (value instanceof Date ? value : new Date(value));

// An instant (ISO string or Date) as India date and time, e.g. "26 Sept 2026, 10:54 am".
export function formatIndiaDateTime(value) {
    if (value === null || value === undefined || value === "") return "";
    const date = toDate(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString("en-IN", DATE_TIME);
}

// A calendar date "YYYY-MM-DD" (already India time, e.g. from an anonymous form)
// as "26 Sept 2026". No time zone conversion: it is a date, not an instant.
export function formatCalendarDate(ymd) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(ymd || ""));
    if (!m) return "";
    return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12)).toLocaleDateString("en-IN", { ...DATE_ONLY, timeZone: "UTC" });
}

// The India calendar date of an instant, as "YYYY-MM-DD" (for date filters).
export function indiaDateKey(value) {
    if (value === null || value === undefined || value === "") return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return String(value);
    const date = toDate(value);
    if (Number.isNaN(date.getTime())) return "";
    const parts = Object.fromEntries(
        new Intl.DateTimeFormat("en-CA", { timeZone: INDIA_TZ, year: "numeric", month: "2-digit", day: "2-digit" })
            .formatToParts(date).map(p => [p.type, p.value])
    );
    return `${parts.year}-${parts.month}-${parts.day}`;
}

// A wall-clock value the owner picked, "YYYY-MM-DDTHH:mm" (already India time),
// formatted without any time zone conversion.
export function formatWallClock(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(value || ""));
    if (!m) return value ? String(value) : "";
    return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]))
        .toLocaleString("en-IN", { ...DATE_TIME, timeZone: "UTC" });
}

// The Results date filter's quick ranges ("Today", "Last 7 days", ...), as
// India calendar dates { from, to }. Shared by the Results table and Insights.
export const QUICK_DATE_RANGES = [
    { days: 0, label: "Today" },
    { days: 7, label: "Last 7 days" },
    { days: 28, label: "Last 4 weeks" },
    { days: 365, label: "Last 12 months" },
];

export function quickDateRange(days, now = Date.now()) {
    return { from: indiaDateKey(new Date(now - days * 86400000)), to: indiaDateKey(new Date(now)) };
}
